import { FormGroup } from "@angular/forms";

export class ValidatorPatterns {
    static readonly Email = String.raw`^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$`;
    static readonly InternationalPhone = String.raw`^$|((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))`;
    static readonly Phone = String.raw`^$|^(\+1 )?(\([0-9]{3}\)\s|[0-9]{3}-)[0-9]{3}-[0-9]{4}$`;
    static readonly RequiredBool = String.raw`(true)$`;
    static readonly RequiredText = `^.{1,}$`;
    static readonly RequiredTextLineBreak = `^(\n|.){1,}$`;
    static readonly Url = String.raw`^$|[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?`;
    static readonly ZipCode = String.raw`^[0-9]{5}(?:-[0-9]{4})?$`;
}